import { Button, Col, Container, Nav, Row, Table } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import GoToTop from "../../components/GoToTop";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import { extractImageUrls } from "../../components/extractImageUrls";
import {
  useDeleteBlogPostMutation,
  useGetBlogPostsQuery,
} from "../../slices/blogPostsApiSlice";
import { useDeleteImageMutation } from "../../slices/imageApiSlice";
import "./BlogPostList.css";

const BlogPostList = () => {
  const { keyword } = useParams();

  const {
    data: blogPosts,
    isLoading,
    error,
    refetch,
  } = useGetBlogPostsQuery({ keyword });
  const [deleteBlogPost, { isLoading: loadingDelete }] =
    useDeleteBlogPostMutation();
  const [deleteImage] = useDeleteImageMutation();

  const deleteHandler = async (id, content, image) => {
    if (window.confirm("해당 글을 삭제하시겠습니까?")) {
      try {
        await deleteBlogPost(id);
        const fileNameBig = image.split("/").pop();
        try {
          await deleteImage(fileNameBig).unwrap();
        } catch (err) {
          toast.error(err?.data?.message || "Failed to delete image");
        }
        const imageUrls = extractImageUrls(content);
        for (const imageUrl of imageUrls) {
          const filename = imageUrl.split("/").pop();
          try {
            await deleteImage(filename).unwrap();
          } catch (err) {
            toast.error(err?.data?.message || "Failed to delete image");
          }
        }
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <Container className="admin-bloglist-container">
      <Row className="align-items-center mb-5">
        <Col>
          <h1 className="text-start">전체 타로마스터 R 글</h1>
        </Col>
      </Row>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          <Table
            striped
            bordered
            hover
            responsive
            className="table-sm"
            variant="dark"
          >
            <thead>
              <tr>
                <th>ID</th>
                <th>TITLE</th>
                <th>ABSTRACT</th>
                <th>DATE</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {blogPosts.map((blogPost) => (
                <tr key={blogPost._id}>
                  <td>{blogPost._id}</td>
                  <td>{blogPost.title}</td>
                  <td>{blogPost.abstract}</td>
                  <td>{blogPost.createdAt}</td>
                  <td>
                    <Nav.Link
                      as={Link}
                      to={`/admin/blog-post/${blogPost._id}/edit`}
                    >
                      <Button variant="light" className="btn-sm mx-2">
                        <FaEdit />
                      </Button>
                    </Nav.Link>
                    <Button
                      variant="danger"
                      className="btn-sm"
                      onClick={() =>
                        deleteHandler(
                          blogPost._id,
                          blogPost.content.ops,
                          blogPost.image
                        )
                      }
                    >
                      <FaTrash style={{ color: "white" }} />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
      <GoToTop />
    </Container>
  );
};

export default BlogPostList;
